import { jsx as _jsx } from "react/jsx-runtime";
import AirplaySvg from "../icons/airplay.svg";
import { useControls } from "../providers/CoreProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";
export const AirplayButton = ({ interactive }) => {
    const controls = useControls();
    const translations = useTranslations();
    if (!controls?.toggleAirplay) {
        return null;
    }
    return (_jsx(PlayerControlButtonComponent, { "aria-label": translations("player__a11y__voice_over_airplay_button"), onClick: controls?.toggleAirplay, interactive: interactive, Icon: _jsx(AirplaySvg, {}), hoverText: translations("player__a11y__hover_label_airplay_button") }));
};
export default AirplayButton;
